<template>
  <SAIPageWrapper :pad-x="false" :pad-y="false" :reveal-footer="false">
    <CarSearchTabs />
    <QuoteSummaryWidget class="q-mt-lg" />
    <QuoteAcceptance />
    <template v-slot:footer v-if="!isAccepted">
      <SummaryActions
        class="print-hide"
        :disable="acceptingQuote"
        :loading-accepting="acceptingQuote"
        @accept="$emit('quote:accept')"
      />
    </template>
  </SAIPageWrapper>
</template>

<script>
import { SAIPageWrapper } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteSummaryPage',
  props: {
    acceptingQuote: Boolean,
    disable: Boolean,
    isAccepted: Boolean
  },
  components: {
    SAIPageWrapper,
    QuoteSummaryWidget: () => import('../../../widgets/quote-summary'),
    SummaryActions: () => import('../../organism/summary-actions'),
    CarSearchTabs: () => import('../../../widgets/car-search-tabs'),
    QuoteAcceptance: () => import('../../../widgets/quote-acceptance')
  }
};
</script>
